import React from 'react'

import SignUpPersonalForm from 'app/components/forms/Auth/SignUpPersonalForm'

const SignUpPersonalFeature: RFC = () => {
  return <SignUpPersonalForm />
}

export default SignUpPersonalFeature
